import { useSelector } from "react-redux";
import { useMemo } from "react";

const useTaskUsage = () => {
  const taskLimit = 10;
  const { taskSet } = useSelector((state) => state.tasks);
  const tasksUsed = useMemo(
    () => Object.values(taskSet).filter((task) => !task.completed).length,
    [taskSet],
  );

  return { tasksUsed, taskLimit };
};

export default useTaskUsage;
